import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var ArrowLeft = function ArrowLeft(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.67676 12.2227C1.67676 12.5986 1.83789 12.9746 2.10645 13.2432L9.15332 20.2686C9.44336 20.5586 9.77637 20.6982 10.1201 20.6982C10.915 20.6982 11.4736 20.1396 11.4736 19.3877C11.4736 18.9795 11.3018 18.6572 11.0547 18.3994L8.62695 15.9609L5.89844 13.458L8.31543 13.5977H20.9053C21.7432 13.5977 22.3125 13.0391 22.3125 12.2227C22.3125 11.4062 21.7432 10.8477 20.9053 10.8477H8.31543L5.89844 10.9766L8.62695 8.48438L11.0547 6.03516C11.3125 5.77734 11.4736 5.45508 11.4736 5.04688C11.4736 4.30566 10.915 3.73633 10.1201 3.73633C9.77637 3.73633 9.44336 3.87598 9.13184 4.17676L2.10645 11.2021C1.83789 11.46 1.67676 11.8467 1.67676 12.2227Z"
  })));
};

ArrowLeft.displayName = 'ArrowLeft';
export default ArrowLeft;